// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"_3itZ9X","text":"_3mc9tG","buttons":"_3jdnle","refundButton":"_89Z6QW","receiveButton":"AwysZe","refundModal":"_2HRze2","shine-lines":"_2SInV8"};